import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import {
  ContactInfo,
  HelpFeedback,
  Purchase,
  PurchasePaymentMethods,
  RequestReceived,
  Shopping
} from '@/modules/perseo-billing/containers/payment-complete/components/index';
import useConstructorPurchaseConfirmation from '@/modules/perseo-billing/containers/payment-complete/hooks/use-constructor-purchase-confirmation';
import useGtmEvents from '@/modules/perseo-billing/containers/payment-complete/hooks/use-gtm-events';
import { useSendCmediaPurchaseEvent } from '@/modules/perseo-billing/containers/payment-complete/hooks/use-send-cmedia-purchase-event.ts';
import {
  isDeviceAndroid,
  isDeviceIos,
  isDeviceKiosco
} from '@/modules/perseo-billing/utils';
import { mergeCustomerData } from '@/modules/perseo-billing/utils/mergeCustomerData.ts';
import { isDni } from '@/modules/shared/types/IdentificationDocumentType';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

import { useSendOrderCompletedOnline } from './hooks/use-send-order-completed-online';

export const PaymentComplete = () => {
  const billing = useAppSelector((state) => state.billing);
  const paymentSuccess = billing.paymentSuccess;
  const order = paymentSuccess?.order;
  const basketSummary = paymentSuccess?.basketSummary ?? [];
  const {
    customer: { data: customerData }
  } = useCustomerContext();

  const customer = mergeCustomerData(paymentSuccess?.customer, customerData);

  const authType = paymentSuccess?.authType;
  const isRegistered = authType === 'registered';
  const isDniEnabled = isRegistered
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();

  const isForeignDocument = isDniEnabled && isDni(customer?.documentType);

  useConstructorPurchaseConfirmation();
  useGtmEvents();
  useSendCmediaPurchaseEvent();
  useSendOrderCompletedOnline();

  const isWebView = isDeviceAndroid() || isDeviceIos();
  const isKiosco = isDeviceKiosco();

  if (!order || !customer) return <></>;

  return (
    <div className="co-flex co-flex-col co-overflow-y-scroll co-w-full co-h-full co-items-center co-mx-auto co-bg-pds-neutral-100">
      <div
        className={`co-flex co-flex-col co-px-16px co-gap-16px co-pt-32px lg:co-px-64px co-pb-16px ${
          isWebView ? 'co-pb-[110px]' : ''
        }`}
      >
        <RequestReceived order={order} customer={customer} />
        <Purchase basketSummary={basketSummary} />
        <PurchasePaymentMethods />
        <ContactInfo
          authType={isKiosco ? 'guest' : authType}
          customer={customer}
          isForeignDocument={isForeignDocument}
        />
        {!isKiosco && !isForeignDocument && (
          <Shopping authType={authType ?? 'guest'} />
        )}
        {!isKiosco && !isForeignDocument && <HelpFeedback />}
      </div>
    </div>
  );
};
